import React, { useState, useEffect, useMemo } from "react";

//PropTypes
import PropTypes from "prop-types";

//components
import DataCard from "../../../components/Cards/DataCard";

//data
import getTableData from "./_time-offs";

import useQueryAuth from "../../../hooks/useQueryAuth";

import useAuth from "../../../hooks/useAuth";

import {GET_DAILY_TIME_OFFS} from "../../../graphql/dayLogs"
import { useTranslation } from "react-i18next";

const TimeOffs = ({ tenant = null, date }) => {
  const [loading, setLoading] = useState(false); //set true when we wish to start lazy loading


  const { t } = useTranslation();

  const { userRoles, storeUserGuid, storeUserTenant } = useAuth();

  const {isEntelligence} = userRoles;

    /**States for Personal Time Offs */
    const [_timeOffs, _setTimeOffs] = useState([]);
    const [_timeOffsNumb, _setTimeOffsNumb] = useState(0);

    const {
      loading: timeOffsLoading,
    } = useQueryAuth(
      GET_DAILY_TIME_OFFS,
      "GetPtosForUsers",
      {
        variables: {
          model: {
            tenantID: isEntelligence
              ? tenant
                ? tenant.tenantGuid
                : null
              : storeUserTenant,
            date: new Date(date).toISOString(),
            userID: storeUserGuid,
          },
        }
      },
      {
        onCompleted: (data) => {
          var array = data?.GetPtosForUsers?.toEntitlementListResponse?.toEntitlements || [];
  
          _setTimeOffs((records) => [...records, ...array]);
          _setTimeOffsNumb(
            data?.GetPtosForUsers?.toEntitlementListResponse?.numberOfRecords || 0
          );
        },
      }
    );

  const _records = useMemo(()=>_timeOffs || [], [_timeOffs]); //holds data
  const _maxRecords = _timeOffsNumb || 0; //holds total number of records in database that satisfy the query

  useEffect(() => {
    if (_records && _records.length > 0) setLoading(false);
  }, [_records]);

  function fetchData() {
    //function that gets records on lazy load

    if (timeOffsLoading) return; //data is already being fetched, we wait for it to at least be fetched

    if (_records.length >= _maxRecords) return; //if data has reached its max

  }

  const _tableData = getTableData(t);

  const { title, headers, render } = _tableData; //holds card title, table headers and the display of data

  const stopLazyLoad = _records.length >= _maxRecords; //if all records have been fetched we no longer wish to lazy load

 
  return (
    <DataCard
      id="dashboard-offs-modal"
      title={title}
      stopLazyLoad={stopLazyLoad}
      onLazyLoad={fetchData}
      tableHeaders={headers}
      render={render}
      data={_records}
      initialLoad={!(timeOffsLoading && _timeOffsNumb === 0)}
      loading={loading}
      setLoading={setLoading}
    />
  );
};

TimeOffs.propTypes = {
  initialLoad: PropTypes.bool,
  data: PropTypes.object,
  next: PropTypes.func,
  waitBatch: PropTypes.bool,
};

TimeOffs.defaultProps = {
  initialLoad: false,
  data: {},
  next: () => {},
  waitBatch: false,
};

export default TimeOffs;
